import label from "@/lang/StaticLabels.js";

// PSLRY Router  - Ø¬Ø¨Ø±Ø§Ù† Ø®Ø¯Ù…Øª  -----------------------------------------------
let routeItems = {
  path: "PSLRY",
  name: "PSLRY",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PSLRYDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PSLRYDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pslry,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pslry/Dashboard.vue"),
    },
    // base Actions -------------------------------------------------------
    {
      path: "taxTable",
      name: "PSLRYTaxTable",
      meta: {
        label: label.page.taxTable,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pslry/base/taxTable/index.vue"),
    },
    {
      path: "settingTransactions",
      name: "PSLRYSettingTransactions",
      meta: {
        label: label.page.settingTransactions,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/transactionInfo/index.vue"),
    },
    {
      path: "occupationCategory",
      name: "PSLRYOccupationCategory",
      meta: {
        label: label.page.occupationCategory,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/occupationCategory/index.vue"),
    },
    {
      path: "nationalityType",
      name: "PSLRYNationalityType",
      meta: {
        label: label.page.nationalityType,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/nationalityType/index.vue"),
    },
    {
      path: "workPlaceStatus",
      name: "PSLRYWorkPlaceStatus",
      meta: {
        label: label.page.workPlaceStatus,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/workPlaceStatus/index.vue"),
    },
    {
      path: "exemptionType",
      name: "PSLRYExemptionType",
      meta: {
        label: label.page.exemptionType,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/exemptionType/index.vue"),
    },
    {
      path: "sampleExcelFiles",
      name: "PSLRYSampleExcelFiles",
      meta: {
        label: label.page.sampleExcelFiles,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/sampleExcelFiles/index.vue"),
    },
    {
      path: "benefitsAndDeduction",
      name: "PSLRYBenefitsAndDeduction",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "benefitsAndDeduction/list",
      children: [
        {
          path: "list",
          name: "PSLRYBenefitsAndDeductionList",
          component: () =>
            import("@/views/modules/pslry/base/benefitsAndDeduction/index.vue"),
          meta: {
            label: label.page.benefitsAndDeduction,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddBenefitsAndDeduction",
          component: () =>
            import("@/views/modules/pslry/base/benefitsAndDeduction/AddEdit"),
          meta: {
            label: label.page.addBenefitsAndDeduction,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditBenefitsAndDeduction",
          component: () =>
            import("@/views/modules/pslry/base/benefitsAndDeduction/AddEdit"),
          meta: {
            label: label.page.editBenefitsAndDeduction,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "insuranceStudio",
      name: "PSLRYInsuranceStudio",
      meta: {
        label: label.page.insuranceStudio,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/insuranceStudio/index.vue"),
    },

    {
      path: "setting",
      name: "PSLRYSetting",
      meta: {
        label: label.page.settings,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pslry/base/setting"),
    },
    {
      path: "payslipSystemControl",
      name: "PSLRYPayslipSystemControl",
      meta: {
        label: label.page.payslipSystemControl,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/payslipSystemControl/index.vue"),
    },
    {
      path: "workingHour",
      name: "PSLRYWorkingHours",
      meta: {
        label: label.page.workingHours,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/workingHours/index.vue"),
    },
    {
      path: "agreementRow",
      name: "PSLRYAgreementRow",
      meta: {
        label: label.page.agreementRow,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/agreementRow/index.vue"),
    },
    {
      path: "insuranceType",
      name: "PSLRYInsuranceType",
      meta: {
        label: label.page.insuranceType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/InsuranceType/index.vue"),
    },
    {
      path: "employmentType",
      name: "PSLRYEmploymentType",
      meta: {
        label: label.page.employmentType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pbase/employmentType/index.vue"),
    },
    {
      path: "jobGroup",
      name: "PSLRYJobGroup",
      meta: {
        label: label.page.jobGroup,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pslry/base/jobGroup/index.vue"),
    },
    {
      path: "taxRateType",
      name: "PSLRYTaxRateType",
      meta: {
        label: label.page.taxRateType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pslry/base/taxRateType"),
    },
    {
      path: "ContractSample",
      name: "PSLRYContractSample",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "contractSample/list",
      children: [
        {
          path: "list",
          name: "PSLRYContractSampleList",
          component: () =>
            import("@/views/modules/pslry/operation/contractSample"),
          meta: {
            label: label.page.contractSample,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddContractSample",
          component: () =>
            import("@/views/modules/pslry/operation/contractSample/AddEdit"),
          meta: {
            label: label.page.addContractSample,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditContractSample",
          component: () =>
            import("@/views/modules/pslry/operation/contractSample/AddEdit"),
          meta: {
            label: label.page.editContractSample,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "Contract",
      name: "PSLRYContract",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "contract/list",
      children: [
        {
          path: "list",
          name: "PSLRYContractList",
          component: () => import("@/views/modules/pslry/operation/contract"),
          meta: {
            label: label.page.contract,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddContract",
          component: () =>
            import("@/views/modules/pslry/operation/contract/AddEdit"),
          meta: {
            label: label.page.addContract,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditContract",
          component: () =>
            import("@/views/modules/pslry/operation/contract/AddEdit"),
          meta: {
            label: label.page.editContract,
            requiresAuth: true,
          },
        },
        {
          path: "editGroup",
          name: "PSLRYEditGroupContract",
          component: () =>
            import(
              "@/views/modules/pslry/operation/contract/EditGroupContract"
            ),
          meta: {
            label: label.page.editGroupContract,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "leave",
      name: "PSLRYLeave",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "leave/list",
      children: [
        {
          path: "list",
          name: "PSLRYLeaveList",
          component: () => import("@/views/modules/pslry/operation/leave"),
          meta: {
            label: label.page.leave,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddLeave",
          component: () =>
            import("@/views/modules/pslry/operation/leave/AddEdit"),
          meta: {
            label: label.page.addLeave,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditLeave",
          component: () =>
            import("@/views/modules/pslry/operation/leave/AddEdit"),
          meta: {
            label: label.page.editLeave,
            requiresAuth: true,
          },
        },
        {
          path: "confirm",
          name: "PSLRYLeaveConfirm",
          component: () =>
            import("@/views/modules/pslry/operation/leave/Confirm"),
          meta: {
            label: label.page.leaveConfirm,
            requiresAuth: true,
          },
        },
        {
          path: "managementCartable",
          name: "PSLRYLeaveManagementCartable",
          component: () =>
            import(
              "@/views/modules/pslry/operation/managementCartable/Leave.vue"
            ),
          meta: {
            label: label.page.leaveManagementCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "advance",
      name: "PSLRYAdvance",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "advance/list",
      children: [
        {
          path: "list",
          name: "PSLRYAdvanceList",
          component: () => import("@/views/modules/pslry/operation/advance"),
          meta: {
            label: label.page.advance,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddAdvance",
          component: () =>
            import("@/views/modules/pslry/operation/advance/AddEdit"),
          meta: {
            label: label.page.addAdvance,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditAdvance",
          component: () =>
            import("@/views/modules/pslry/operation/advance/AddEdit"),
          meta: {
            label: label.page.editAdvance,
            requiresAuth: true,
          },
        },
        {
          path: "addGroup",
          name: "PSLRYAddGroupAdvance",
          component: () =>
            import("@/views/modules/pslry/operation/advance/AddGroup"),
          meta: {
            label: label.page.addGroupAdvance,
            requiresAuth: true,
          },
        },
        {
          path: "confirm",
          name: "PSLRYAdvanceConfirm",
          component: () =>
            import("@/views/modules/pslry/operation/advance/Confirm"),
          meta: {
            label: label.page.advanceConfirm,
            requiresAuth: true,
          },
        },
        {
          path: "managementCartable",
          name: "PSLRYAdvanceManagementCartable",
          component: () =>
            import(
              "@/views/modules/pslry/operation/managementCartable/Advance.vue"
            ),
          meta: {
            label: label.page.advanceManagementCartable,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "contractType",
      name: "PSLRYContractType",
      meta: {
        label: label.page.contractType,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/contractType/index.vue"),
    },
    {
      path: "additionalContractParameter",
      name: "PSLRYAdditionalContractParameter",
      meta: {
        label: label.page.additionalContractParameter,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pslry/base/additionalContractParameter/index.vue"
        ),
    },
    {
      path: "personnel",
      name: "PSLRYPersonnel",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "personnel/list",
      children: [
        {
          path: "list",
          name: "PSLRYPersonnelList",
          component: () => import("@/views/modules/pslry/base/personnel"),
          meta: {
            label: label.page.personnel,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddPersonnel",
          component: () =>
            import("@/views/modules/pslry/base/personnel/AddEdit"),
          meta: {
            label: label.page.addPersonnel,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditPersonnel",
          component: () =>
            import("@/views/modules/pslry/base/personnel/AddEdit"),
          meta: {
            label: label.page.editPersonnel,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "studyFieldType",
      name: "PSLRYStudyFieldType",
      meta: {
        label: label.page.studyFieldType,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/studyFieldType/index.vue"),
    },
    {
      path: "degree",
      name: "PSLRYDegree",
      meta: {
        label: label.page.degree,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pslry/base/degree/index.vue"),
    },
    {
      path: "department",
      name: "PSLRYDepartment",
      meta: {
        label: label.page.department,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/base/department/index.vue"),
    },
    {
      path: "formula",
      name: "PSLRYFormula",
      meta: {
        label: label.page.formula,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pslry/base/formula/index.vue"),
    },
    {
      path: "formula/add",
      name: "PSLRYAddFormula",
      component: () => import("@/views/modules/pslry/base/formula/AddEdit.vue"),
      meta: {
        label: label.page.addFormula,
        requiresAuth: true,
      },
    },
    {
      path: "formula/edit/:id",
      name: "PSLRYEditFormula",
      component: () => import("@/views/modules/pslry/base/formula/AddEdit.vue"),
      meta: {
        label: label.page.editFormula,
        requiresAuth: true,
      },
    },
    {
      path: "payrollEmployee",
      name: "PSLRYPayrollEmployee",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "payrollEmployee/list",
      children: [
        {
          path: "list",
          name: "PSLRYPayrollEmployeeList",
          component: () =>
            import("@/views/modules/pslry/operation/payrollEmployee"),
          meta: {
            label: label.page.payrollEmployee,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditPayrollEmployee",
          component: () =>
            import("@/views/modules/pslry/operation/payrollEmployee/Info"),
          meta: {
            label: label.page.editPayrollEmployee,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "insuranceEmployee",
      name: "PSLRYInsuranceEmployee",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "insuranceEmployee/list",
      children: [
        {
          path: "list",
          name: "PSLRYInsuranceEmployeeList",
          component: () =>
            import("@/views/modules/pslry/operation/insuranceEmployee"),
          meta: {
            label: label.page.insuranceEmployee,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddInsuranceEmployee",
          component: () =>
            import("@/views/modules/pslry/operation/insuranceEmployee/Info"),
          meta: {
            label: label.page.addInsuranceEmployee,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditInsuranceEmployee",
          component: () =>
            import("@/views/modules/pslry/operation/insuranceEmployee/Info"),
          meta: {
            label: label.page.editInsuranceEmployee,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "taxEmployee",
      name: "PSLRYTaxEmployee",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "taxEmployee/list",
      children: [
        {
          path: "list",
          name: "PSLRYTaxEmployeeList",
          component: () =>
            import("@/views/modules/pslry/operation/taxEmployee"),
          meta: {
            label: label.page.taxEmployee,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddTaxEmployee",
          component: () =>
            import("@/views/modules/pslry/operation/taxEmployee/Info"),
          meta: {
            label: label.page.addTaxEmployee,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditTaxEmployee",
          component: () =>
            import("@/views/modules/pslry/operation/taxEmployee/Info"),
          meta: {
            label: label.page.editTaxEmployee,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "salaryAndBenefitsReport",
      name: "PSLRYSalaryAndBenefitsReport",
      meta: {
        label: label.page.salaryAndBenefitsReport,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/reports/salaryAndBenefitsReport"),
    },
    {
      path: "employeePayrollSummaryPersonnelReport",
      name: "PSLRYEmployeePayrollSummaryPersonnelReport",
      meta: {
        label: label.page.employeePayrollSummaryPersonnelReport,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pslry/reports/employeePayrollSummaryPersonnelReport"
        ),
    },
    {
      path: "payrollEmployeeSummary",
      name: "PSLRYPayrollEmployeeSummaryReport",
      meta: {
        label: label.page.payrollEmployeeSummary,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/reports/payrollEmployeeSummary"),
    },
    {
      path: "advanceReport",
      name: "PSLRYAdvanceReport",
      meta: {
        label: label.page.advanceReport,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/reports/advance"),
    },
    {
      path: "payslipReport",
      name: "PSLRYPayslipReport",
      meta: {
        label: label.page.payslipReport,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/reports/payslip"),
    },
    {
      path: "bankExportTemplate",
      name: "PSLRYBankExportTemplate",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "bankExportTemplate/list",
      children: [
        {
          path: "list",
          name: "PSLRYBankExportTemplateList",
          component: () =>
            import("@/views/modules/pslry/base/bankExportTemplate/index.vue"),
          meta: {
            label: label.page.bankExportTemplate,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PSLRYAddBankExportTemplate",
          component: () =>
            import("@/views/modules/pslry/base/bankExportTemplate/AddEdit"),
          meta: {
            label: label.page.addBankExportTemplate,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PSLRYEditBankExportTemplate",
          component: () =>
            import("@/views/modules/pslry/base/bankExportTemplate/AddEdit"),
          meta: {
            label: label.page.editBankExportTemplate,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "bankExport",
      name: "PSLRYBankExport",
      meta: {
        label: label.page.bankExport,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/operation/bankExport/index.vue"),
    },
    {
      path: "bankExportHistory",
      name: "PSLRYBankExportHistory",
      meta: {
        label: label.page.bankExportHistory,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pslry/operation/bankExport/History.vue"),
    },
  ],
};

export default routeItems;
